import { 
  useCallback, 
  useContext, 
  createContext
} from 'react'

import { useHistory } from 'react-router-dom';
import { capsiMonteiroLobatoService } from '../api/capsServices/capsiMonteiroLobatoService';
import { decrypt } from '../helpers/cryptography';

const CapsContext = createContext({});

export const CapsProvider = ({ children }) => {
    const history = useHistory();

    const getAllPacientes = useCallback(async (pageNumber, limit, filterBy, orderBy) => {
            try {
                const response = await capsiMonteiroLobatoService.allPacientes(pageNumber, limit, filterBy, orderBy);

                return response;
            } catch (error) {
                console.log(error);
            }
    }, []);

    const getPacientesTotais = useCallback(async () => {
        try {
            const response = await capsiMonteiroLobatoService.pacientesTotais();

            return response;
        } catch (error) {
            console.log(error);
        }
    }, []);

    const getPacienteById = useCallback(async (id) => {
        try {
            const response = await capsiMonteiroLobatoService.getPaciente(id);

            const decryptedResponse = {
                ...response,
                cartaoSus: response.cartaoSus ? decrypt(response.cartaoSus) : '',
                cep: response.cep ? decrypt(response.cep) : '',
                contatoTrabalho: response.contatoTrabalho ? decrypt(response.contatoTrabalho) : '',
                cpf: response.cpf ? decrypt(response.cpf) : '',
                localTrabalho: response.localTrabalho ? decrypt(response.localTrabalho) : '',
                logradouro: response.logradouro ? decrypt(response.logradouro) : '',
                mae: response.mae ? decrypt(response.mae) : '',
                nomeSocial: response.nomeSocial ? decrypt(response.nomeSocial) : '',
                nomeTelefoneCurador: response.nomeTelefoneCurador ? decrypt(response.nomeTelefoneCurador) : '',
                nomeUsuario: response.nomeUsuario ? decrypt(response.nomeUsuario) : '',
                pai: response.pai ? decrypt(response.pai) : '',
                pontoReferencia: response.pontoReferencia ? decrypt(response.pontoReferencia) : '',
                principalReferencia: response.principalReferencia ? decrypt(response.principalReferencia) : '',
                rg: response.rg ? decrypt(response.rg) : '',
                telefoneContato: response.telefoneContato ? decrypt(response.telefoneContato) : '',
                telefoneContato2: response.telefoneContato2 ? decrypt(response.telefoneContato2) : '',
            }

            return decryptedResponse;
        } catch (error) {
            console.log(error);
        }
    }, []);

    const updatePaciente = useCallback(async (id, data) => {
        try {
            const response = await capsiMonteiroLobatoService.update(id, data);

            return response;
        } catch (error) {
            console.log(error);
        }
    }, []);

    const deletePaciente = useCallback(async (id) => {
        try {
            const response = await capsiMonteiroLobatoService.delete(id);

            if (!response.ok) {
                throw new Error('Ocorreu um erro inesperado');
            }
        } catch (error) {
            console.log(error);
        }
    }, []);

    const createPaciente = useCallback(async (data) => {
        try {
            const response = await capsiMonteiroLobatoService.create(data);

            if (!response.ok) {
                throw new Error('Ocorreu um erro inesperado');
            }
        } catch (error) {
            console.log(error);
        }
    }, []);

    const initialValues = {
        prontuario: '',
        dataPreenchimento: '',
        dataAtivacaoProntuario: '',
        nomeUsuario: '',
        nomeSocial: '',
        dataNascimento: '',
        identidadeGenero: '',
        orientacaoSexual: '',
        qualOrientacao: '',
        mae: '',
        pai: '',
        cartaoSus: '',
        cpf: '',
        rg: '',
        racaCor: '',
        nacionalidade: '',
        naturalidade: '',
        estadoCivil: '',
        deficiencia: '',
        deficienciaOutra: '',
        situacaoMoradia: '',
        qualMoradia: '',
        dataInicioAbrigamento: '',
        tempoSituacaoRua: '',
        cep: '',
        logradouro: '',
        numero: '',
        complemento: '',
        bairro: '',
        subBairro: '',
        municipio: '',
        uf: '',
        pontoReferencia: '',
        telefoneContato: '',
        telefoneContato2: '',
        coletaDeLixo: '',
        aguaEncanada: '',
        escolaridade: '',
        anoEscolar: '',
        nomeEscola: '',
        trabalhou30Dias: '',
        vigenciaAuxilioDoenca: '',
        profissaoOcupacao: '',
        localTrabalho: '',
        contatoTrabalho: '',
        fonteRenda: '',
        rendaFamiliarAproximada: '',
        qtdPessoasDestinoRenda: '',
        beneficiosAssistenciaSocial: '',
        outroBeneficio: '',
        curatelado: '',
        nomeTelefoneCurador: '',
        suporteFamiliar: '',
        principalReferencia: '',
        conflitoLei: '',
        dataInicioMedidaPena: '',
        dataTerminoMedidaPena: '',
        localCumprimentoMedidaPena: '',
        unidadeApsReferencia: '',
        equipeApsReferenciaTelefone: '',
        entradaCaps: '',
        encaminhadoPor: '',
        encaminhadoOutroLocal: '',
        tratamentoAnteriorSaudeMental: '',
        localTratamentoAnterior: '',
        tempoAcompanhamento: '',
        usoAlcoolDrogas: '',
        quaisAlcoolDrogas: '',
        usoMedicacaoPsiquiatrica: '',
        qualMedicacaoPsiquiatrica: '',
        desinstitucionalizacao: '',
        localAnoDesins: '',
        estrategiaDesins: '',
        outroDesins: '',
        cid: '',
        ciap2: '',
        classificacaoRisco: '',
        referencia: '',
        correferencia: '',
        medicoReferencia: '',
        situacaoCadastro: '',
        inativoMotivo: '',
        outroInativoMotivo: '',
    };

    const MOCKUP_TESTE = {
        prontuario: '1203',
        dataPreenchimento: '01/01/2001',
        dataAtivacaoProntuario: '01/01/2001',
        nomeUsuario: 'Teste PDF',
        nomeSocial: 'Teste PDF Social',
        dataNascimento: '01/01/2001',
        identidadeGenero: 'Ignorado / Não Informado',
        mae: 'Teste PDF Mãe',
        pai: 'Teste PDF Pai',
        cartaoSus: '12345678910',
        cpf: '111.111.111-11',
        rg: '222222222',
        racaCor: 'Preta',
        nacionalidade: 'Brasileira',
        naturalidade: 'Niterói',
        estadoCivil: 'Solteiro',
        deficiencia: 'Auditiva',
        deficienciaOutra: '',
        situacaoMoradia: 'Com Residência Fixa',
        qualMoradia: '',
        dataInicioAbrigamento: '01/01/2001',
        tempoSituacaoRua: '',
        cep: '33333-333',
        logradouro: 'Rua Santa Clara',
        numero: '120',
        complemento: '',
        bairro: "Ponta D'Areia",
        subBairro: '',
        municipio: 'Niterói',
        uf: 'RJ',
        pontoReferencia: 'Perto do estaleiro',
        telefoneContato: '(99)99999-9999',
        telefoneContato2: '(99)99999-9999',
        coletaDeLixo: 'Sim',
        aguaEncanada: 'Não',
        escolaridade: 'Ensino Médio Completo',
        anoEscolar: '',
        nomeEscola: 'Escola do Saber',
        trabalhou30Dias: 'Auxílio Doença',
        vigenciaAuxilioDoenca: '01/01/2001',
        profissaoOcupacao: 'Trabalhador',
        localTrabalho: 'Trabalho',
        contatoTrabalho: '(99)99999-9999',
        fonteRenda: 'Não Informado',
        rendaFamiliarAproximada: 'Sem Rendimento',
        qtdPessoasDestinoRenda: 'Não Informado',
        beneficiosAssistenciaSocial: 'Não',
        outroBeneficio: '',
        curatelado: 'Sim',
        nomeTelefoneCurador: 'John Doe/(99)99999-9999',
        suporteFamiliar: 'Não Informado',
        principalReferencia: 'Pai',
        conflitoLei: 'Medida de Segurança',
        dataInicioMedidaPena: '01/01/2001',
        dataTerminoMedidaPena: '01/01/2001',
        localCumprimentoMedidaPena: 'Bangu II',
        unidadeApsReferencia: 'MMF DA GROTA II (JOSE MARTI II)',
        equipeApsReferenciaTelefone: 'GROTA 112 - 0000296287',
        entradaCaps: 'Demanda Espontânea',
        encaminhadoPor: '',
        encaminhadoOutroLocal: '',
        tratamentoAnteriorSaudeMental: 'Não Informado',
        localTratamentoAnterior: '',
        tempoAcompanhamento: '3 meses',
        usoAlcoolDrogas: 'Não',
        quaisAlcoolDrogas: '',
        usoMedicacaoPsiquiatrica: 'Sim',
        qualMedicacaoPsiquiatrica: 'Alguma',
        desinstitucionalizacao: 'Sim',
        localAnoDesins: 'Lá/2001/2002',
        estrategiaDesins: 'Retorno Familiar',
        outroDesins: '',
        cid: '7777777',
        ciap2: '88888888',
        classificacaoRisco: 'Azul',
        situacaoCadastro: 'Ativo',
        inativoMotivo: '',
        outroInativoMotivo: '',
    }
    
    const goBackToList = (currentCaps) => {
        history.push({
            pathname: '/caps',
            state: { currentCapsState: currentCaps }
        })
    }

    return (
        <CapsContext.Provider
          value={{
            getAllPacientes,
            getPacienteById,
            updatePaciente,
            deletePaciente,
            createPaciente,
            initialValues,
            goBackToList,
            getPacientesTotais,
            MOCKUP_TESTE,
          }}
        >
            {children}
        </CapsContext.Provider>
    );
}

export const useCaps = () => useContext(CapsContext);
